import { render, staticRenderFns } from "./plate-keyboard.vue?vue&type=template&id=2e0950f6&scoped=true&lang=pug"
import script from "./plate-keyboard.vue?vue&type=script&lang=ts"
export * from "./plate-keyboard.vue?vue&type=script&lang=ts"
import style0 from "./plate-keyboard.vue?vue&type=style&index=0&id=2e0950f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0950f6",
  null
  
)

export default component.exports